import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { yupResolver } from "@hookform/resolvers/yup";
import { numeroActaSchema, onSubmitBuscarRecibo } from "./handlers";
import TextInput from "../../components/ReactHookForm/TextInput";
import ContainedMuniSpinner from "../../components/MuniSpinner/ContainedMuniSpinner";

const FormPagar = ({ setRecibo }) => {
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    // mode: 'all',
    resolver: yupResolver(numeroActaSchema),
  });

  return (
    <Box className='mt-4'>
      <Form onSubmit={handleSubmit((data) => onSubmitBuscarRecibo(data, setRecibo, setIsLoading))}>
        <fieldset disabled={isLoading}>
          <Box className='d-flex gap-4' sx={{ width: "100%" }}>
            <Box style={{ width: "90%" }}>
              <TextInput name='numero_acta' label='Numero de Acta *' register={register} errors={errors?.numero_acta} />
            </Box>
            <Button type='submit' disabled={isLoading} style={{ height: "38px", alignSelf: "end" }} className='mb-3'>
              {isLoading ? (
                <Box className='w-full h-full'>
                  <ContainedMuniSpinner height={25} width={25} size={35} />{" "}
                </Box>
              ) : (
                <SearchIcon />
              )}
            </Button>
          </Box>
        </fieldset>

        <div className='alert alert-primary' role='alert'>
          <Typography className='mb-1'>El formato del acta debe ser una de las siguientes opciones: </Typography>
          <ul style={{ marginBottom: "0" }}>
            <li>DTP-999999999999999</li>
            <li>DTM-999999999999999</li>
          </ul>
        </div>
      </Form>
    </Box>
  );
};

export default FormPagar;
